import { type FC, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';

import { QuoteFooter } from '@/views/screens/Shipment/components/QuoteFooter';

import { routeFileSelector } from '../../../utilz/i18n';
import WithFilter from '../../screens/common/WithFilter';
import QuotePageHeader from '../../screens/Shipment/components/QuotePageHeader';
import QuoteContent from '../../screens/Shipment/QuoteContent';
import SearchQuoteFilters from '../../screens/Shipment/SearchQuoteFilters';

const SearchQuotePage: FC = () => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <>
      <WithFilter
        filterElement={<SearchQuoteFilters />}
        headerContent={<QuotePageHeader />}
        contentElement={<QuoteContent />}
        filterTitle={t('translation:default.fields.filter')}
        footerContent={<QuoteFooter />}
        labelForTestId="search-quote"
        pageTitle={t('translation:searchQuote.title')}
      />
      <Outlet />
    </>
  );
};

export default memo(SearchQuotePage);
